"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _g;
var BiggerImage = function BiggerImage(props) {
  return /*#__PURE__*/_react.default.createElement("svg", Object.assign({
    viewBox: "0 0 17 18"
  }, props), _g || (_g = /*#__PURE__*/_react.default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M9.177 14.887h7.293V1.289H2.873V9.38m-1.727 3.002h5.087v5.087H1.146z",
    stroke: "currentColor"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12.672 5.92l-3.99 3.99a.591.591 0 1 1-.836-.837l3.986-3.986H9.801a.591.591 0 1 1 0-1.183h3.476a.592.592 0 0 1 .592.597l-.065 3.4a.592.592 0 0 1-1.184-.011l.052-1.97z",
    fill: "currentColor"
  }))));
};
var _default = exports.default = BiggerImage;